function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Camada_1",
  "data-name": "Camada 1"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_415",
  "data-name": "Pfad 415",
  d: "M0,0V26H26V0ZM23.619,2.381V8.3H2.381V2.381ZM2.381,23.619V10.682H23.619V23.619Z"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_443",
  "data-name": "Rechteck 443",
  width: 2.381,
  height: 2.381,
  transform: "translate(5.368 18.107)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_444",
  "data-name": "Rechteck 444",
  width: 2.381,
  height: 2.381,
  transform: "translate(9.662 18.107)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_445",
  "data-name": "Rechteck 445",
  width: 2.381,
  height: 2.381,
  transform: "translate(13.956 18.107)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_446",
  "data-name": "Rechteck 446",
  width: 2.381,
  height: 2.381,
  transform: "translate(5.368 13.813)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_447",
  "data-name": "Rechteck 447",
  width: 2.381,
  height: 2.381,
  transform: "translate(9.662 13.813)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_448",
  "data-name": "Rechteck 448",
  width: 2.381,
  height: 2.381,
  transform: "translate(13.956 13.813)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rechteck_449",
  "data-name": "Rechteck 449",
  width: 2.381,
  height: 2.381,
  transform: "translate(18.251 13.813)"
}));

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calender",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 25.999,
    viewBox: "0 0 26 25.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ec6b9c9a.svg";
export { ForwardRef as ReactComponent };